import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const dashboardApi = {
  async getStatus() {
    return await authInstance.get(`/dashboard/getStatus`).then((res) => res.data);
  }
};
